import { render, staticRenderFns } from "./formation.vue?vue&type=template&id=734c6ad1"
import script from "./formation.vue?vue&type=script&lang=js"
export * from "./formation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports